import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import CampaignHashtagsHeader from '../../components/campaign-hashtags-header';
import LiveBanner from './live-banner';

// JSON:API returns hashtags as a comma-separated string; GraphQL returns an array.
const toHashtagArray = hashtags => (_.isString(hashtags)
  ? _.compact(_.map(hashtags.split(','), _.trim))
  : hashtags);

// Same heights as the loaded header so nothing below it shifts on load.
const titleRowStyle = {
  display: 'flex',
  alignItems: 'baseline',
  flexWrap: 'wrap',
  marginBottom: '1.25rem',
  paddingBottom: '1.25rem',
  borderBottom: '1px solid #ececf0',
};
const BANNER_HEIGHT = 76;

const CampaignHeader = ({ campaign }) => {
  if (_.isEmpty(campaign)) {
    return (
      <div style={{ marginBottom: '1.5rem' }}>
        <div style={titleRowStyle}>
          <div className="dz-skeleton" style={{ width: 300, height: 30 }} />
        </div>
        <div className="dz-skeleton" style={{ width: '100%', height: BANNER_HEIGHT }} />
      </div>
    );
  }

  return (
    <div style={{ marginBottom: '1.5rem' }}>
      <div style={titleRowStyle}>
        <h2 style={{ margin: 0, fontWeight: 700, lineHeight: 1.2 }}>{campaign.name}</h2>
        <span style={{ marginLeft: '0.85rem' }}>
          <CampaignHashtagsHeader
            hashtags={toHashtagArray(campaign.hashtags)}
            locations={campaign.locations || undefined}
          />
        </span>
      </div>
      <LiveBanner campaign={campaign} />
    </div>
  );
};

CampaignHeader.propTypes = {
  campaign: PropTypes.shape({
    name: PropTypes.string,
    hashtags: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
    locations: PropTypes.arrayOf(PropTypes.object),
    liveDate: PropTypes.string,
    endDate: PropTypes.string,
  }).isRequired,
};

export default CampaignHeader;



/** WEBPACK FOOTER **
 ** ./src/containers/large-campaign/campaign-header.js
 **/